/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IndexResponse
 */
export interface IndexResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexResponse
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IndexResponse
     */
    nbDocuments: number;
}

/**
 * Check if a given object implements the IndexResponse interface.
 */
export function instanceOfIndexResponse(value: object): value is IndexResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nbDocuments' in value) || value['nbDocuments'] === undefined) return false;
    return true;
}

export function IndexResponseFromJSON(json: any): IndexResponse {
    return IndexResponseFromJSONTyped(json, false);
}

export function IndexResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndexResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'nbDocuments': json['nbDocuments'],
    };
}

export function IndexResponseToJSON(value?: IndexResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'nbDocuments': value['nbDocuments'],
    };
}

